import { Link } from "react-router";
import { buttonStyles } from "../components/ui";

export function NotFoundPage() {
  return (
    <div className="flex flex-col items-center gap-4 py-24 text-center">
      <p className="text-sm font-medium text-fg-subtle">404</p>
      <h1 className="text-2xl font-semibold tracking-tight">No such page</h1>
      <Link to="/" className={buttonStyles("secondary")}>
        Back to overview
      </Link>
    </div>
  );
}
